import React from "react";
import { ROLE } from "Common/constants/roles";
import ProductionItemsPage from "Common/Components/ProductionItemsPage";

// کالاهای در حال تولید = قلم‌هایی که item_status آن‌ها in_production است.
// پیشروی یک گام: in_production → produced، بازگشت یک گام: in_production → sales_order
const Index = () => (
  <ProductionItemsPage
    pageTitle="کالاهای در حال تولید"
    itemStatus="in_production"
    advanceLabel="اتمام تولید"
    advanceConfirmText="آیا اتمام تولید این کالا را تأیید می‌کنید؟"
    advanceSuccessText="تولید کالا به پایان رسید و به فهرست کالاهای تولید شده منتقل گردید."
    canRevert
    advanceRoles={[ROLE.PRODUCTION_EXPERT]}
    revertRoles={[ROLE.PRODUCTION_EXPERT]}
    emptyText="هیچ کالایی در حال تولید نیست"
  />
);

export default Index;
